// Test IDs for the 12steps dashboard. Keys camelCase, values kebab-case.

export const DASHBOARD = {
        searchButton: 'dashboard-search-button',
        intentionInput: 'intention-input',
        intentionSave: 'intention-save',
        seeSteps: 'see-steps',
        journalWrite: 'journal-write',
        journalInput: 'journal-input',
        journalSave: 'journal-save',
        shareButton: 'share-button',
};
